function reduceNodeOffset(elem, acc = { top: 0, left: 0 }) {
  const result = {
    top: acc.top + elem.offsetTop,
    left: acc.left + elem.offsetLeft
  };
  return elem.offsetParent ? reduceNodeOffset(elem.offsetParent, result) : result;
}

export { reduceNodeOffset };
//# sourceMappingURL=dom.reduce-node-offset.js.map
